
import { defineComponent } from 'vue'
import ActiveUserMixin from '~/mixins/activeUserMixin'

import { AppFeatures } from '~/types/permTypes'
import { OwnerFeatureType } from '~/types/ownerTypes'

export default defineComponent({
  name: 'AddNewRepo',
  mixins: [ActiveUserMixin],
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    defaultActiveTab: {
      type: Number,
      default: 0
    },
    showMonorepo: {
      type: Boolean,
      default: true
    },
    analyzerShortcode: {
      type: String,
      default: ''
    },
    transformerShortcode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      activeTabIndex: 0,
      monorepoFeatureAllowed: false
    }
  },

  created() {
    this.activeTabIndex = this.defaultActiveTab
  },

  async fetch() {
    if (this.showMonorepo) {
      //? For some reason, activeUser (and hence activeOwner and activeProvider) was unavailable
      //? when the fetch hook of this component ran. Hence, explicitly fetching it if unavailble.
      if (!this.activeOwner || !this.activeProvider) {
        await this.fetchActiveUserIfLoggedIn()
      }

      if (this.activeOwner) {
        try {
          this.monorepoFeatureAllowed = await this.$isFeatureAvailable(OwnerFeatureType.MONOREPO, {
            login: this.activeOwner,
            provider: this.$providerMetaMap[this.activeProvider].value
          })

          if (this.activeTabIndex >= this.tabItemList.length) {
            this.activeTabIndex = 0
          }
        } catch (error) {
          this.$logErrorAndToast(
            error as Error,
            'Unable to fetch details about the team. Please contact support.'
          )
        }
      }
    }
  },

  watch: {
    '$route.path': {
      handler() {
        this.closeModal()
      }
    },
    refetchKeyForRouteChange: {
      handler() {
        this.refetchDataOnChange()
      }
    }
  },

  computed: {
    tabItemList() {
      const tabsConfig = [
        {
          title: 'Activate a repository',
          visible: true,
          component: 'ActivateSingleRepo',
          bindings: {
            'analyzer-shortcode': this.analyzerShortcode,
            'transformer-shortcode': this.transformerShortcode
          }
        },
        {
          title: 'Monorepos',
          visible: this.showMonorepoSection && this.showMonorepo,
          component: 'ActivateSingleRepo',
          bindings: {
            'analyzer-shortcode': this.analyzerShortcode,
            'list-monorepos-only': true,
            'transformer-shortcode': this.transformerShortcode
          }
        }
      ]

      return tabsConfig.filter((item) => item.visible)
    },

    activeTabItem() {
      return this.tabItemList[this.activeTabIndex] ?? this.tabItemList[0]
    },

    showMonorepoSection() {
      return (
        this.monorepoFeatureAllowed &&
        this.$gateKeeper.provider(AppFeatures.MONOREPO, this.activeProvider)
      )
    },

    refetchKeyForRouteChange() {
      return `${this.activeProvider}-${this.activeOwner}`
    }
  },

  methods: {
    updateActiveIndex(index: number) {
      if (index < this.tabItemList.length) {
        this.activeTabIndex = index
      }
    },

    closeModal() {
      this.$emit('close')
    },

    refetchDataOnChange() {
      this.$fetch()
    }
  }
})
